import React from 'react';
import PropTypes from 'prop-types';
import {ReactComponent as BackgroundIcon} from 'images/dashboard/wide-suggest.svg';
import './WideSuggestedAction.styl';
import connectToStores from 'alt-utils/lib/connectToStores';
import ManagerDashboardStore from 'stores/ManagerDashboardStore';
import ManagerDashboardActions from 'actions/ManagerDashboardActions';
import moment from 'moment';
import SuggestedActionDescription from 'components/dashboard/admin/SuggestedActionDescription';
import {suggestedActionsMap} from 'components/dashboard/admin/AdminSuggestedActions';
import User from 'records/User';
import {shouldUpdate} from 'components/StatsPage2.utils';

const widgetId = 'exec-suggested-actions';

@connectToStores
export default class WideSuggestedAction extends React.PureComponent {
  static getStores() {
    return [ManagerDashboardStore];
  }

  static getPropsFromStores() {
    return {widgets: ManagerDashboardStore.getState().widgets};
  }

  componentDidMount() {
    this.getWidget();
  }

  componentDidUpdate(prevProps) {
    if (shouldUpdate(prevProps, this.props, false)) {
      this.getWidget();
    }
  }

  getWidget() {
    const {startDate, endDate} = this.props;
    const widgetConfig = {
      startDate: startDate,
      endDate: endDate,
      // Arbitrarily large number here to ensure we get data about all of our available managers
      maxResults: 99,
      widgetId: widgetId,
      widgetType: 'EXEC_ACTION_RECOMMENDATIONS',
    };

    ManagerDashboardActions.getWidget.defer([widgetConfig, null]);
  }

  render() {
    const {widgets, manager} = this.props;
    if (!widgets) return null;
    if (!manager) return null;

    const widget = widgets.get(widgetId);
    if (!widget) return null;

    const rec = widget.recommendations.find(r => r.managerId === manager.id) || {
      type: 'NO_RECOMMENDATIONS',
      managerId: manager.id,
      displayName: manager.getDisplayName(),
      firstName: manager.firstName,
    };
    const noRecommendation = rec.type === 'NO_RECOMMENDATIONS';

    const template = suggestedActionsMap.get(rec.type);
    if (!template) {
      // this is actually not possible, because we only pick the ones we know in the first place
      console.error('Encountered unknown recommendation type', rec.type, rec);
      return null;
    }

    // TODO this could be a WavyCard
    return (
      <div className="wide-suggested-action">
        <div className="header">
          <BackgroundIcon className={`background-icon ${rec.type.toLowerCase()}`} />
          <span>
            {noRecommendation
              ? `${manager.firstName} is doing great!`
              : `Suggested Action: ${template.title}`}
          </span>
        </div>
        <div className="body">
          <SuggestedActionDescription rec={rec} template={template} />
        </div>
      </div>
    );
  }
}

WideSuggestedAction.propTypes = {
  manager: PropTypes.instanceOf(User),
  startDate: PropTypes.instanceOf(moment),
  endDate: PropTypes.instanceOf(moment),
};
